module.exports = __webpack_public_path__ + "f083ba20c7d08b44e7bb0b472304f864.svg";